module.exports = __webpack_public_path__ + "static/media/340.60aa6f55.png";